/* global axios */
// Explicit scope captured by the caller; never resolve a changing route after await.
const url = (accountId, inboxId) =>
  `/api/v1/accounts/${accountId}/inboxes/${inboxId}/whatsapp_templates`;

export default {
  list(accountId, inboxId, cursor, signal) {
    return axios.get(url(accountId, inboxId), { params: { cursor }, signal });
  },
  show(accountId, inboxId, id, signal) {
    return axios.get(`${url(accountId, inboxId)}/${id}`, { signal });
  },
  upload(accountId, inboxId, file, mediaFormat, key, signal) {
    const body = new FormData();
    body.append('file', file);
    body.append('media_format', mediaFormat);
    return axios.post(`${url(accountId, inboxId)}/uploads`, body, {
      signal,
      headers: { 'Idempotency-Key': key },
    });
  },
  mutate(accountId, inboxId, operation, signal) {
    const { action, id, body, key } = operation;
    const endpoint = `${url(accountId, inboxId)}${id ? `/${id}` : ''}${
      action === 'submit' ? `/${action}` : ''
    }`;
    return axios[action === 'update' ? 'patch' : 'post'](endpoint, body, {
      signal,
      headers: { 'Idempotency-Key': key },
    });
  },
};
